import Logo from '@assets/images/common/brand/logo-primary.svg';
import ConstructionIcon from '@assets/images/common/icon/construction/construction-gary.svg';
import SvgIconLock from '@assets/images/common/icon/lock/SvgIconLock';
import { brandColors } from '@src/assets/colors/brandColors';
import { useCompanyAuth } from '@src/context/auth/useCompanyAuth';
import Button from '@src/ui/elements/button/Button';
import UserGuideLink from '@src/ui/elements/button/UserGuideLink';
import CompanyAccountMenu from '@src/ui/templates/Company/Navbar/CompanyAccountMenu';
import { NavItem } from '@src/ui/templates/Company/NavMenu/types';
import { Link, useNavigate } from 'react-router-dom';

const renderLockIcon = (current: boolean) => (
  <SvgIconLock
    color={current ? brandColors['500'] : '#292929'}
    style={{
      width: '24px',
      height: '24px',
    }}
  />
);
const renderConstructionIcon = () => (
  <img
    src={ConstructionIcon}
    alt=''
    width='24'
    height='24'
  />
);

const CompanyNavbar = ({
  navItems,
  needLogo = false,
}: {
  navItems: NavItem[];
  needLogo?: boolean;
}) => {
  const navigate = useNavigate();
  const companyAuth = useCompanyAuth();

  if (companyAuth.profile === undefined) {
    return '';
  }

  return (
    <header
      className={`sticky top-0 z-50 flex h-[61px] w-full border-b border-gray-200 bg-white ${needLogo ? 'pl-3' : 'pl-8 xl:pl-3'} lg:hidden`}
    >
      <div className='flex w-full items-center justify-between'>
        {needLogo && (
          <Link
            to={companyAuth.profile?.topPageLink || ''}
            className='shrink-0'
          >
            <img
              src={Logo}
              alt=''
            />
          </Link>
        )}
        <nav className={`size-full ${needLogo ? 'px-8' : 'pr-4'}`}>
          <ul className='flex h-full items-center gap-2 xl:gap-1 xl:text-sm'>
            {navItems.map((item: NavItem, index: number) => (
              <li
                key={index}
                className={`relative h-full border-b-2 transition-colors
                  ${item.current ? 'border-primary text-primary' : 'border-white'}
                  ${item.isComingSoon ? 'text-gray-400' : ''}
                  ${index < 4 ? 'flex-[0_0_auto]' : ''}
                `}
              >
                {item.isComingSoon ? (
                  <>
                    <span className='peer flex h-full items-center truncate px-2 xl:px-1'>
                      {renderConstructionIcon()}
                      <span className='truncate'>{item.title}</span>
                    </span>
                    <span className='absolute bottom-[-10px] left-1/2 -translate-x-1/2 rounded border border-solid border-gray-200 bg-white px-2 py-1 text-[10px] text-black opacity-0 transition-all peer-hover:visible peer-hover:opacity-100'>
                      Coming Soon
                    </span>
                  </>
                ) : (
                  <button
                    className='flex h-full items-center px-2 xl:px-1'
                    onClick={() => navigate(item.link)}
                    data-nav-target={item.link}
                  >
                    {item.isLocked ? renderLockIcon(item.current) : ''}
                    {companyAuth.profile?.isLogin &&
                    !companyAuth.profile.user?.isAdmin &&
                    item.adminOnly ? (
                      <span
                        className={`mr-[4px] translate-y-px border border-solid border-current px-1 text-[10px] ${item.current ? 'text-primary' : 'text-black'}`}
                      >
                        管理者
                      </span>
                    ) : (
                      ''
                    )}
                    <span>{item.title}</span>
                  </button>
                )}
              </li>
            ))}
          </ul>
        </nav>
        <UserGuideLink
          userType='company'
          device='pc'
          color='gray'
        />
        {companyAuth.profile.isLogin ? (
          <div className='z-10 mt-auto flex items-center bg-white'>
            {/* <div className='flex size-[60px] items-center justify-center'>
              <Notification color='dark' />
            </div> */}
            <div className='h-[30px] w-px bg-gray-200'></div>
            <div className='w-[270px]'>
              <CompanyAccountMenu />
            </div>
          </div>
        ) : (
          <div className='flex flex-[0_0_auto] items-center gap-[10px] border-l border-solid border-l-gray-200 pl-6 pr-2 xl:gap-[5px] xl:pl-3'>
            <Button
              size='s'
              fullRounded
              outline
              onClick={() => navigate('/login')}
            >
              ログイン
            </Button>
            <Button
              size='s'
              fullRounded
              outline
              onClick={() => navigate('/registration')}
            >
              新規会員登録
            </Button>
          </div>
        )}
      </div>
    </header>
  );
};

export default CompanyNavbar;
